import {
  ConstraintActionBarShimmer,
  ConstraintInfoShimmer,
  ConstraintValuesShimmer,
} from "components/loadingSkeletons/ConstraintLoadingSkeletons";
import { TitleShimmer } from "components/loadingSkeletons/GeneralLoadingSkeletons";
import { InfoPageTitleWithLoading } from "components/shared/InfoPageTitle";
import { ConstraintActionBarWithLoading } from "components/constraint/ConstraintActionBar";
import { ConstraintInfoCardWithLoading } from "components/constraint/ConstraintInfoCard";
import { ConstraintGroupedListWithLoading } from "components/constraint/ConstraintGroupedList";
import NoItemSelectedDisplay from "components/shared/NoItemSelectedDisplay";
import useConstraintInfoProvider from "hooks/constraint/useConstraintInfoProvider";
import { IAgreementObjectId } from "models/agreements";

function ConstraintInfo({
  constraintId,
  isNothingSelected,
}: IAgreementObjectId) {
  const { constraint, constraintValues, isLoading } =
    useConstraintInfoProvider(constraintId);

    let sortedConstraintValues = constraintValues;
    if (constraint?.name === "Country") {
        sortedConstraintValues = [...(constraintValues ?? [])].sort((a, b) => {
        const aDisplay = a.display && a.display.trim() !== "" ? a.display : a.name;
        const bDisplay = b.display && b.display.trim() !== "" ? b.display : b.name;
        return aDisplay.localeCompare(bDisplay);
        });
    }
    
  return (
    <>
      {isNothingSelected && <NoItemSelectedDisplay itemType="constraint" />}
      {!isNothingSelected && (
        <>
          <InfoPageTitleWithLoading
            isLoading={isLoading}
            LoadingSubstitute={TitleShimmer}
            title={
              constraint?.display !== ""
                ? constraint?.display
                : constraint?.name
            }
          />
          <ConstraintActionBarWithLoading
            isLoading={isLoading}
            LoadingSubstitute={ConstraintActionBarShimmer}
            constraintId={constraintId}
            constraintValues={sortedConstraintValues}
          />
          <ConstraintInfoCardWithLoading
            isLoading={isLoading}
            LoadingSubstitute={ConstraintInfoShimmer}
            constraint={constraint}
          />
          <ConstraintGroupedListWithLoading
            isLoading={isLoading}
            LoadingSubstitute={ConstraintValuesShimmer}
            constraintValues={sortedConstraintValues}
          />
        </>
      )}
    </>
  );
}

export default ConstraintInfo;
